import { ModalProps } from "antd/lib/modal/Modal";
import { Alert, message, Modal, Radio, Spin } from "antd";
import React, { useEffect } from "react";
import Form, { useForm } from "rc-field-form";
import useRequestFn from "../../../../Utils/useRequestFn";
import { ResultMessage } from "../../../../components/ResultMessage";
import useRequest, { errorMessage } from "../../../../Utils/useRequest";
import {
    AskSetParams,
    BusinessKey,
    getNoticeSet,
    isAskSet,
    isDiscSet,
    ProjectSetParams,
    saveNoticeSet
} from "../../../../API/discuss";
import useDeviceType from "../../../../Utils/useDeviceType";
import FieldWithErrorHaveLabel from "../../../../components/FieldWithErrorHaveLabel";
import lodash from "lodash-es";

interface Props extends ModalProps {
    businessKey: BusinessKey;
    onSuccess: () => void;
}
const DefaultProps = {
    preserve: false,
    initialValue: "1",
    span: [10, 12]
};

const Index = ({ businessKey, onSuccess, ...props }: Props) => {
    const [form] = useForm<AskSetParams | ProjectSetParams>();

    const [saveAction, { loading: saveLoading }] = useRequestFn(saveNoticeSet);

    async function onFinish(data: AskSetParams | ProjectSetParams) {
        try {
            const filteredObject = lodash.omitBy(data, lodash.isEmpty);
            await saveAction({
                businessKey,
                noticeConfigJson: filteredObject
            });
            onSuccess?.();
            message.success("保存成功", 2);
        } catch (e) {
            ResultMessage.error(errorMessage(e));
        }
    }

    const [data, { loading: getLoading }] = useRequest(
        () => getNoticeSet({ businessKey }),
        {},
        [businessKey]
    );
    useEffect(() => {
        if (
            businessKey === BusinessKey.Aks &&
            data &&
            isAskSet(data.noticeConfigJson)
        ) {
            const {
                myQuestionHasNewFloor,
                myQuestionHasNewReply,
                myFloorHasUpgrade,
                myReplyHasUpgrade
            } = data.noticeConfigJson;
            form.setFieldsValue({
                myQuestionHasNewFloor,
                myQuestionHasNewReply,
                myFloorHasUpgrade,
                myReplyHasUpgrade
            });
        }
        if (
            businessKey === BusinessKey.Discuss &&
            data &&
            isDiscSet(data.noticeConfigJson)
        ) {
            const { hasNewDislike, hasNewFloor, hasNewLik, hasNewReply } =
                data.noticeConfigJson;
            form.setFieldsValue({
                hasNewDislike,
                hasNewFloor,
                hasNewLik,
                hasNewReply
            });
        }
    }, [data]);

    const { isMobile } = useDeviceType();

    return (
        <Modal
            {...props}
            okButtonProps={{ loading: [saveLoading, getLoading].some(i => i) }}
            width={500}
            centered={isMobile}
            title="通知设置"
            onOk={form.submit}>
            <Spin spinning={[saveLoading, getLoading].some(i => i)}>
                {businessKey === BusinessKey.Discuss && (
                    <Alert message="此设置针对所有课程" />
                )}
                <Form form={form} onFinish={onFinish} style={{ marginTop: 30 }}>
                    {businessKey === BusinessKey.Aks && (
                        <>
                            <FieldWithErrorHaveLabel
                                {...DefaultProps}
                                align="middle"
                                label="我的提问有新回答"
                                name="myQuestionHasNewFloor">
                                <Radio.Group>
                                    <Radio value="0">不通知</Radio>
                                    <Radio value="1">通知</Radio>
                                </Radio.Group>
                            </FieldWithErrorHaveLabel>
                            <FieldWithErrorHaveLabel
                                {...DefaultProps}
                                align="middle"
                                label="我的提问有新回复"
                                name="myQuestionHasNewReply">
                                <Radio.Group>
                                    <Radio value="0">不通知</Radio>
                                    <Radio value="1">通知</Radio>
                                </Radio.Group>
                            </FieldWithErrorHaveLabel>
                            <FieldWithErrorHaveLabel
                                {...DefaultProps}
                                align="middle"
                                label="我回答的问题有更新"
                                name="myFloorHasUpgrade">
                                <Radio.Group>
                                    <Radio value="0">不通知</Radio>
                                    <Radio value="1">通知</Radio>
                                </Radio.Group>
                            </FieldWithErrorHaveLabel>
                            <FieldWithErrorHaveLabel
                                {...DefaultProps}
                                align="middle"
                                label="我回复的问题有更新"
                                name="myReplyHasUpgrade">
                                <Radio.Group>
                                    <Radio value="0">不通知</Radio>
                                    <Radio value="1">通知</Radio>
                                </Radio.Group>
                            </FieldWithErrorHaveLabel>
                        </>
                    )}
                    {businessKey === BusinessKey.Discuss && (
                        <>
                            <FieldWithErrorHaveLabel
                                {...DefaultProps}
                                align="middle"
                                label="有新发言"
                                name="hasNewFloor">
                                <Radio.Group>
                                    <Radio value="0">不通知</Radio>
                                    <Radio value="1">通知</Radio>
                                </Radio.Group>
                            </FieldWithErrorHaveLabel>
                            <FieldWithErrorHaveLabel
                                {...DefaultProps}
                                align="middle"
                                label="我的发言有新回复"
                                name="hasNewReply">
                                <Radio.Group>
                                    <Radio value="0">不通知</Radio>
                                    <Radio value="1">通知</Radio>
                                </Radio.Group>
                            </FieldWithErrorHaveLabel>
                            <FieldWithErrorHaveLabel
                                {...DefaultProps}
                                align="middle"
                                label="我的发言有新点赞"
                                name="hasNewLik">
                                <Radio.Group>
                                    <Radio value="0">不通知</Radio>
                                    <Radio value="1">通知</Radio>
                                </Radio.Group>
                            </FieldWithErrorHaveLabel>
                            <FieldWithErrorHaveLabel
                                {...DefaultProps}
                                align="middle"
                                label="我的发言有新点踩"
                                name="hasNewDislike">
                                <Radio.Group>
                                    <Radio value="0">不通知</Radio>
                                    <Radio value="1">通知</Radio>
                                </Radio.Group>
                            </FieldWithErrorHaveLabel>
                        </>
                    )}
                </Form>
            </Spin>
        </Modal>
    );
};
export default Index;
